import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withModifiers as _withModifiers, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-2fa47119"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "checkbox",
  id: "btn-mas"
}, null, -1))
const _hoisted_3 = { class: "redes" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-list",
  _mstvisible: "2"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn-mas" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "btn-mas",
    class: "fa fa-cog"
  })
], -1))
const _hoisted_6 = {
  key: 0,
  class: "spin"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: _imports_0
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "general" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Crear Prefactura", -1))
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Fechas")
], -1))
const _hoisted_13 = { class: "grid" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "fechaPago"
}, "Fecha de Prefactura:", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "fechaRecepcion"
}, "Fecha de Entrega:", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "fechaPago"
}, "Fecha de Vencimiento:", -1))
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Entidades")
], -1))
const _hoisted_19 = { class: "grid" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "medico"
}, "Médico:", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "medico"
}, "Cliente:", -1))
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Facturación")
], -1))
const _hoisted_24 = { class: "grid" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "bruto"
}, "Total:", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "descServicio"
}, "Descripción:", -1))
const _hoisted_27 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Navbar),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "a yellow",
          to: "/documentos"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _hoisted_5
    ]),
    (_ctx.cargando)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_9, [
      _createElementVNode("form", null, [
        _createElementVNode("fieldset", null, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", null, [
                _hoisted_14,
                _withDirectives(_createElementVNode("input", {
                  id: "fechaPago",
                  type: "datetime-local",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.documento.fechaProceso) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.documento.fechaProceso]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_15,
                _withDirectives(_createElementVNode("input", {
                  id: "fechaRecepcion",
                  type: "datetime-local",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.documento.fechaEfectivo) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.documento.fechaEfectivo]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_16,
                _withDirectives(_createElementVNode("input", {
                  id: "fechaPago",
                  type: "datetime-local",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.documento.fechaVence) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.documento.fechaVence]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", null, [
                _hoisted_20,
                _withDirectives(_createElementVNode("select", {
                  id: "medico",
                  type: "medico",
                  class: "form-select",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.documento.medico) = $event)),
                  onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectMedico(_ctx.documento.medico)))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.medicos, (medico, index) => {
                    return (_openBlock(), _createElementBlock("option", { key: index }, _toDisplayString(medico.emisor), 1))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.documento.medico]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_21,
                _withDirectives(_createElementVNode("select", {
                  id: "cliente",
                  type: "cliente",
                  class: "form-select",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.documento.descCliente) = $event)),
                  onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectCliente(_ctx.documento.descCliente)))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clientes, (cliente, index) => {
                    return (_openBlock(), _createElementBlock("option", { key: index }, _toDisplayString(cliente.descripcion), 1))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.documento.descCliente]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", null, [
                _hoisted_25,
                _withDirectives(_createElementVNode("input", {
                  id: "bruto",
                  type: "number",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.documento.prefactura) = $event)),
                  class: "form-control input-r"
                }, null, 512), [
                  [_vModelText, _ctx.documento.prefactura]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_26,
                _withDirectives(_createElementVNode("input", {
                  id: "descServicio",
                  type: "descServicio",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.documento.descServicios) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.documento.descServicios]
                ])
              ])
            ])
          ]),
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.saveDocumento()), ["prevent"])),
            disabled: 
            !_ctx.documento.fechaProceso ||
            !_ctx.documento.fechaEfectivo ||
            !_ctx.documento.fechaVence ||
            !_ctx.documento.medico ||
            !_ctx.documento.descServicios ||
            !_ctx.documento.descCliente ||
            !_ctx.documento.prefactura
          
          }, " Guardar ", 8, _hoisted_27)
        ])
      ])
    ], 512), [
      [_vShow, !_ctx.cargando]
    ])
  ], 64))
}